import componentInitializer from "@/frontend/utils/componentInitializer"
import Vue, { defineAsyncComponent } from "vue"
import store from "@/store"
import { i18n } from "@/lib/vue/plugins/i18n"

let listingsPageVm = null

// vue-turbo calls $destroy on turbo:before-cache — we just clear our reference
// so the old DOM subtree (including FA SVG icons) becomes eligible for GC immediately
document.addEventListener("turbo:before-cache", () => {
  listingsPageVm = null
})

componentInitializer(() => {
  const element = document.getElementById("vue-listings-page")

  if (element) {
    listingsPageVm?.$destroy()
    listingsPageVm = null

    const ListingsPage = defineAsyncComponent(() => import("@/pages/ListingsPage/index.vue"))
    const filters = JSON.parse(element.dataset.filters)
    listingsPageVm = new Vue({
      el: element,
      store,
      i18n,
      render: (h) =>
        h(ListingsPage, {
          props: {
            filterData: filters,
            longtail: {
              id: element.dataset.longtailId,
              keyword: element.dataset.longtailKeyword,
              headline: element.dataset.longtailHeadline,
              content: element.dataset.longtailContent,
            },
            competition: {
              slug: element.dataset.competitionSlug,
              name: element.dataset.competitionName,
              categories: JSON.parse(element.dataset.competitionCategories || "[]"),
              categoryTitle: element.dataset.competitionCategoryTitle,
            },
            guestFavourites: JSON.parse(element.dataset.guestFavourites) || [],
          },
        }),
    })
  } else {
    listingsPageVm?.$destroy()
    listingsPageVm = null
  }
}, "ListingsPage")

componentInitializer(() => {
  const match = document.location.pathname.match(/\/artworks|\/Artwork\//)

  if (match) {
    const setTitle = () => {
      $("#session-body .modal-title").html("Login to follow artists")
    }
    setTitle()
    $(document).on("modal:login-show", setTitle)
  }
})
